import { ITime } from "./time.interface";

export interface IAdvisor {
  id: number;
  name: string;
  timesToWork: ITime[];
}
